import type React from 'react';
import type { SimplePage } from 'interfaces/content/articles/Post';
import RawHtml from 'utils/miscUtils/rawHtml';
import PresentedBy, { type PresentedByProps } from 'components/PresentedBy';
import Heading from 'styles/typography/Heading';
import { StaticContainer, StaticPageWrapper } from './StaticStyles';

export interface StaticProps {
  page: SimplePage;
  presentedBy?: PresentedByProps;
  subDomain?: string;
}

const StaticPage: React.FC<StaticProps> = ({ page, presentedBy, subDomain }) => {
  const { content } = page;

  return (
    <StaticPageWrapper>
      {presentedBy && <PresentedBy {...presentedBy} />}
      <StaticContainer className={subDomain}>
        {page.title && (
          <Heading
            as='h1'
            $fontFamily='graphikCond'
            $size={{ default: 'xlarge' }}
          >
            {page.title}
          </Heading>
        )}
        {RawHtml({ html: content })}
      </StaticContainer>
    </StaticPageWrapper>
  );
};

export { StaticPage };
